export function GlobalSubstituteEvent() {
  const goalImgSrc = "/images/match-events/substitute-new.svg";

  return (
    <div className="player-event substitute-player-event">
      <img src={goalImgSrc} height={8} width={8} alt={"goal"} />
    </div>
  );
}
